var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0154 30.4565L1.0708 30.33V5.45654L21.0154 5.5828V30.4565Z",
    fill: "#E50C22",
    stroke: "#B90315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56741 21.2139H4.33822C4.21917 21.2139 4.12268 21.1174 4.12268 20.9986V17.157C4.12268 16.1463 4.94219 15.327 5.95269 15.327C6.96344 15.327 7.7827 16.1463 7.7827 17.157V20.9986C7.7827 21.1174 7.68622 21.2139 7.56741 21.2139Z",
    fill: "#B90315"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3277 21.2139H9.09847C8.97966 21.2139 8.88318 21.1174 8.88318 20.9986V17.157C8.88318 16.1463 9.70244 15.327 10.7132 15.327C11.7237 15.327 12.5432 16.1463 12.5432 17.157V20.9986C12.5432 21.1174 12.4465 21.2139 12.3277 21.2139Z",
    fill: "#B90315"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.088 21.2139H13.8589C13.7398 21.2139 13.6433 21.1174 13.6433 20.9986V17.157C13.6433 16.1463 14.4628 15.327 15.4733 15.327C16.4841 15.327 17.3033 16.1463 17.3033 17.157V20.9986C17.3033 21.1174 17.2068 21.2139 17.088 21.2139Z",
    fill: "#B90315"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4912 30.2316H7.59505C7.46805 30.2316 7.36487 30.1284 7.36487 30.0012V25.1278C7.36487 24.0473 8.24068 23.1715 9.32088 23.1715H12.7654C13.8456 23.1715 14.7216 24.0473 14.7216 25.1278V30.0012C14.7216 30.1284 14.6187 30.2316 14.4912 30.2316Z",
    fill: "#B90315"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56741 14.2056H4.33822C4.21917 14.2056 4.12268 14.1091 4.12268 13.9903V10.1487C4.12268 9.13774 4.94219 8.31873 5.95269 8.31873C6.96344 8.31873 7.7827 9.13774 7.7827 10.1487V13.9903C7.7827 14.1091 7.68622 14.2056 7.56741 14.2056Z",
    fill: "#B90315"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3277 14.2056H9.09847C8.97966 14.2056 8.88318 14.1091 8.88318 13.9903V10.1487C8.88318 9.13774 9.70244 8.31873 10.7132 8.31873C11.7237 8.31873 12.5432 9.13774 12.5432 10.1487V13.9903C12.5432 14.1091 12.4465 14.2056 12.3277 14.2056Z",
    fill: "#B90315"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.088 14.2056H13.8589C13.7398 14.2056 13.6433 14.1091 13.6433 13.9903V10.1487C13.6433 9.13774 14.4628 8.31873 15.4733 8.31873C16.4841 8.31873 17.3033 9.13774 17.3033 10.1487V13.9903C17.3033 14.1091 17.2068 14.2056 17.088 14.2056Z",
    fill: "#B90315"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3248 4.22461L11.3143 0.061575C11.1174 -0.020525 10.8985 -0.020525 10.7015 0.061575L0.691115 4.22461C0.36854 4.3588 0.156494 4.68919 0.156494 5.05727C0.156494 5.55136 0.533141 5.95144 0.997786 5.95144H21.0184C21.483 5.95144 21.8597 5.55136 21.8597 5.05727C21.8597 4.68919 21.6473 4.3588 21.3248 4.22461Z",
    fill: "#B90315"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94507 21.6453H17.4514V20.7826H3.94507V21.6453Z",
    fill: "#B90315"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94507 14.6367H17.4514V13.7743H3.94507V14.6367Z",
    fill: "#B90315"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.50a44271.svg";
export { ForwardRef as ReactComponent };